import { motion } from 'framer-motion';
import { Unlock, Target } from 'lucide-react';

export function BarriersSection() {
  return (
    <section id="barriers" className="py-20 px-4">
      <div className="w-full">
        {/* Big Hero Card Section */}
        <div className="w-full mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-blue-50 rounded-3xl shadow-sm border border-blue-100 hover:shadow-md transition-all duration-300"
          >
            <div className="rounded-3xl overflow-hidden">
              <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
                  className="p-6 lg:p-12"
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Reveal the Root Cause of Barriers
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              The Personality Breakthrough Profile delves deep to uncover the precise blocks holding you 
              or your clients back from achieving their goals. By identifying these barriers, 
              the assessment provides clarity on the true causes of present-time conditions, 
              paving the way for effective solutions.
            </p>
            
            <div className="space-y-6">
                    <div className="bg-emerald-50 rounded-xl p-6 border border-emerald-100">
                <h3 className="text-xl font-semibold text-gray-900 mb-2 flex items-center gap-2">
                  <Target className="w-6 h-6 text-emerald-600" />
                  For Personal Development Seekers
                </h3>
                <p className="text-gray-600">
                  Understand the underlying issues driving your challenges and receive 
                  actionable steps to overcome them.
                </p>
              </div>
              
                    <div className="bg-purple-50 rounded-xl p-6 border border-purple-100">
                <h3 className="text-xl font-semibold text-gray-900 mb-2 flex items-center gap-2">
                  <Unlock className="w-6 h-6 text-purple-600" />
                  For Coaches and Practitioners
                </h3>
                <p className="text-gray-600">
                  Use the assessment as a diagnostic tool to guide your clients toward 
                  eliminating their presenting problems and achieving breakthroughs.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
                  className="p-6 lg:p-12"
          >
                  <div className="bg-orange-50 rounded-3xl p-8 border border-orange-100">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">
              What Makes The Personality Breakthrough Profile Unique?
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-gray-400 mt-2" />
                <div>
                  <h4 className="text-gray-900 font-medium mb-1">
                    Integration of Traits and Emotions
                  </h4>
                  <p className="text-gray-600">
                    Understand how emotional states influence your ability to take bold actions 
                    or build relationships.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-gray-400 mt-2" />
                <div>
                  <h4 className="text-gray-900 font-medium mb-1">
                    Dynamic Feedback
                  </h4>
                  <p className="text-gray-600">
                    Get real-time insights that evolve with you.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-2 h-2 rounded-full bg-gray-400 mt-2" />
                <div>
                  <h4 className="text-gray-900 font-medium mb-1">
                    Customizable Reports
                  </h4>
                  <p className="text-gray-600">
                    Tailor your experience to personal or professional contexts.
                  </p>
                </div>
              </li>
            </ul>
                  </div>
          </motion.div>
        </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}